<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card max-width="75%" width="500" flat>
        <v-row v-if="contadorDatos === 0 || contadorDatos === 1" class="d-flex">
          <h1 class="mb-4">Ingresa tus datos</h1>
        </v-row>
        <!-- Datos -->
        <v-form ref="form1" id="form1">
          <v-row v-if="contadorDatos === 0">
            <v-text-field
              v-model="formOkBoy.nombreCliente"
              outlined
              label="Nombre:"
              placeholder="Escribe tu nombre aquí"
              :counter="200"
              :rules="nameRules"
              maxlength="200"
            ></v-text-field>
          </v-row>
          <v-row v-if="contadorDatos === 0">
            <v-text-field
              v-model="formOkBoy.numeroCelular"
              outlined
              label="Número de celular:"
              placeholder="10 dígitos"
              :counter="10"
              :rules="phoneRules"
              maxlength="10"
            ></v-text-field>
          </v-row>
          <v-row v-if="contadorDatos === 0">
            <v-text-field
              v-model="formOkBoy.email"
              outlined
              label="Email:"
              placeholder="example@mail.com"
              :counter="100"
              :rules="emailRules"
              maxlength="100"
            ></v-text-field>
          </v-row>
          <v-row v-if="contadorDatos === 0 || contadorDatos === 1">
            <p class="subtitle-2">
              Te enviaremos un SMS para confirmar tu cuenta
            </p>
          </v-row>
        </v-form>
        <!-- Confirmación -->
        <v-form ref="form2" id="form2">
          <v-row v-if="contadorDatos === 1">
            <v-btn text x-small color="primary" class="mb-6" @click="prev()"
              >¿No te llegó? Envíar de nuevo</v-btn
            >
          </v-row>
          <v-row v-if="contadorDatos === 1">
            <v-text-field
              v-model="formOkBoy.codigoConfirmacion"
              class="mb-6"
              outlined
              label="Código de confirmación:"
              placeholder="Código de 6 dígitos"
              :counter="6"
              :rules="codeRules"
              maxlength="6"
            ></v-text-field>
          </v-row>
        </v-form>
        <!-- Dirección -->
        <v-form ref="form3" id="form3">
          <v-row v-if="contadorDatos === 2" class="d-flex">
            <h1 class="mb-4">Registra tu dirección</h1>
          </v-row>
          <!-- <v-row v-if="contadorDatos === 2">
            <v-text-field
              v-model="formOkBoy.direccionServicio"
              outlined
              label="Dirección:"
              placeholder="Escribe tu dirección aquí"
              prepend-icon="mdi-map-marker"
              :rules="directionRules"
            ></v-text-field>
          </v-row> -->
          <!-- <v-row v-if="contadorDatos === 2">
            <p class="subtitle-2">Arrastra para modificar</p>
          </v-row> -->
          <v-row
            v-if="contadorDatos === 2"
            class="mb-6"
            align="center"
            justify="center"
          >
            <v-card width="500" height="400" elevation="0">
              <!-- <v-row align="center" justify="center">Map</v-row> -->
              <MapAddDirecctionVue />
            </v-card>
          </v-row>
          <v-row v-if="contadorDatos === 2">
            <v-text-field
              v-model="formOkBoy.address.numInt"
              outlined
              label="Número interior:"
              placeholder="Eje: 101, Piso 4, casa 2"
              :counter="20"
              maxlength="20"
            ></v-text-field>
          </v-row>
          <v-row v-if="contadorDatos === 2">
            <v-textarea
              v-model="formOkBoy.address.reference"
              outlined
              label="Indicaciones o comentarios:"
              placeholder="Casa roja, barda azul..."
              :rules="referenciaRules"
              :counter="100"
              maxlength="100"
            ></v-textarea>
          </v-row>
        </v-form>

        <v-row>
          <v-col>
            <v-btn color="secondary" text block @click="back()">Cancelar</v-btn>
          </v-col>
          <v-col>
            <v-btn
              v-if="contadorDatos < 2"
              class="buttonPrimary"
              block
              @click="nextForm()"
              >Continuar</v-btn
            >
            <v-btn
              v-if="contadorDatos >= 2"
              :disabled="coverageFlag"
              class="buttonPrimary"
              block
              @click="next()"
              >Siguiente</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";
import MapAddDirecctionVue from "./MapAddDirecction.vue";
import Coverage from "../statics/coverage";
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  computed: {
    ...mapFields([
      "landingCounter",
      "contadorDatos",
      "coverageFlag",
      "formOkBoy",
      "showMessage",
      "message",
      "loader"
    ]),
  },
  components: {
    MapAddDirecctionVue,
  },
  data() {
    return {
      // contadorDatos: 0,
      nameRules: [
        (v) => !!v || "El nombre es requerido.", //
      ],
      phoneRules: [
        (v) => !!v || "El número celular es requerido.", //
        (v) => (v && v.length <= 10) || "El número debe ser de 10 dígitos",
        (v) => (v && v.length >= 10) || "El número debe ser de 10 dígitos",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
      emailRules: [
        (v) => !!v || "El email es requerido.", //
        (v) => !(v && v.length < 3) || "El email debe ser de al menos 3 dígitos",
        (v) => !(v && v.length > 100) || "El email no debe ser de mayor a 100 dígitos",
        (v) => RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(v) || "Ingresa un email válido",
      ],
      codeRules: [
        (v) => !!v || "El código de confirmación es requerido.", //
        (v) => (v && v.length <= 6) || "El código debe ser de 6 dígitos",
        (v) => RegExp("[0-9]+$").test(v) || "Ingresa sólo números",
      ],
      referenciaRules: [
        (v) => !!v || "La dirección es requerida.", //
      ],
    };
  },
  methods: {
    nextForm() {
      switch (this.contadorDatos) {
        case 0:
          if (this.$refs.form1.validate()) {
            this.contadorDatos++;
            //Enviar los datos del numero de telefono para general el código de validación.
            mixpanel.track('Click Datos Contacto', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular, 
              Email:this.formOkBoy.email});
            this.sendNumber(this.formOkBoy.numeroCelular, this.formOkBoy.email);
          }
          break;
        case 1:
          if (this.$refs.form2.validate()) {
            this.confirmNum(
              this.formOkBoy.numeroCelular,
              this.formOkBoy.codigoConfirmacion
            );
          }
          break;
      }
    },
    next() {
      if (this.$refs.form3.validate()) {
        this.checkCoverage();
      }
    },
    back() {
      this.$router.push({ name: "Home" });
      location.reload();
    },
    prev() {
      this.contadorDatos--;
    },
    checkCoverage() {
      if (
        (this.formOkBoy.coordenadasMap.lat !== 0 &&
        this.formOkBoy.coordenadasMap.lng !== 0 ) && this.formOkBoy.address.zipcode
      ) {
        if(this.formOkBoy.tipoServicio === 'Cilindro'){
          let zipcode = this.formOkBoy.address.zipcode.substr(-20,2).trim()
          if(Coverage[this.formOkBoy.tipoServicio].indexOf(zipcode).toString() === '-1'){
              this.showMessage = true;
              this.message =
                  "Por el momento no contamos con cobertura en tu localidad, estamos trabajando para expandir nuestras fronteras.";
              this.coverageFlag = true;
              //mixpanel.track('#form3', 'Ingreso Dirección Incorrecta');
              mixpanel.track('Ingreso Dirección Incorrecta', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular, Domicilio: this.formOkBoy.address});
              return;
          }
          this.landingCounter++;
          return;
        }
    
        let api = Axios.get(config.apiBaseUrl + "/coverage", {
          params: {
            latitude: this.formOkBoy.address.latitude,
            longitude: this.formOkBoy.address.longitude,
            zipCode: this.formOkBoy.address.zipcode
          },
          headers: {
            "x-api-key": config.apiKey,
          },
        })
          .then((response) => {
            const status = [
              200,
              204
            ]
            if (status.includes(response.status)) {
              this.landingCounter++;
              mixpanel.track('Ingreso Dirección Correcta', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular, Domicilio: this.formOkBoy.address});
            }
          })
          .catch((error) => {
            console.error(error);
            this.showMessage = true;
            this.message =
              "Por el momento no contamos con cobertura en tu localidad, estamos trabajando para expandir nuestras fronteras.";
            this.coverageFlag = true;
            mixpanel.track('Ingreso Dirección Incorrecta', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular, Domicilio: this.formOkBoy.address});
          });
      } else {
        this.showMessage = true;
        this.message = "Favor de ingresar una dirección válida";
        mixpanel.track('Ingreso Dirección Incorrecta', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular, Domicilio: this.formOkBoy.address});
      }
    },
    sendNumber(numberPhone, email) {
      let api = Axios.post(
        config.apiBaseUrl + "/customer/validate",
        {
          phoneNumber: numberPhone,
          email
        },
        {
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          return Axios.get(
            config.apiBaseUrl + "/services/" + numberPhone + "/has-back-buy",
            {
              headers: {
                "x-api-key": config.apiKey,
              },
            }
          );
        })
        .then((response) => {
          if (response.data.hasBuyBack === false) {
            this.formOkBoy.usuarioNuevo = true;
            // this.formOkBoy.cuponServicio = 'CUPON100'
            this.formOkBoy.descuento = 0;
          } else {
            this.formOkBoy.usuarioNuevo = false;
            this.formOkBoy.descuento = 0;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    confirmNum(numberPhone, corfimCode) {
      let api = Axios.get(config.apiBaseUrl + "/customer/validate", {
        params: {
          phoneNumber: numberPhone,
          token: corfimCode,
        },
        headers: {
          "x-api-key": config.apiKey,
        },
      })
        .then((response) => {
          this.contadorDatos++;
          mixpanel.track('Verificación Correcta', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular});
        })
        .catch((error) => {
          this.showMessage = true;
          this.message = "Código no valido.";
          mixpanel.track('Verificación Incorrecta ', {Nombre:this.formOkBoy.nombreCliente, Telefono:this.formOkBoy.numeroCelular});
          console.error(error);
        });
    },
  },
};
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': 'https://okboy.app/account',
    'pageTitle': 'Customer Contact Info'
  });
</script>

<style scoped>
.mapa {
  height: 425px;
}
.backgroundColor {
  background-color: #f1f3f6;
}
.theme--light.v-sheet {
    background-color: #f1f3f6;
    border-color: #f1f3f6;
    color: rgba(0, 0, 0, 0.87);
}
</style>